import { useState } from "react";
import ShareSheet from "./ShareSheet";
import ReactDOM from "react-dom/client";
import ShareMemberSheet from "./SharerMemberSheet";
import AddressSheet from "./AddressSheet";
import LinkShareSheet from "./LinkShareSheet";
import SecuritySheet from "./SecuritySheet";
import useGetShareSetting from "../Share/useGetShareSetting";
import { message } from "antd";
import { LinkValidPeriodType, PermissionChoose } from "@/constants/share";

export interface IShareProps {
  visible?: boolean;
  streamName: string;
  title: string;
  children?: React.ReactNode;
}

const ShareActionSheet: React.FC<IShareProps> = ({ visible, streamName, title, children }) => {
  const {
    isCompany,
    isPassWord,
    shareSetting,
    shareInfo,
    mySharePermission,
    updateShareScope,
    updatePassword,
    onShareSettingChange,
    sharerList,
    editable,
    inviteMember,
    removeShareMember,
    updateShareMenber,
  } = useGetShareSetting(streamName);

  const [showShare, setShowShare] = useState(visible ?? false);
  const [showShareMember, setShowShareMember] = useState(false);
  const [showAddress, setShowAddress] = useState(false);
  const [showLinkShare, setShowLinkShare] = useState(false);
  const [showSecurity, setShowSecurity] = useState(false);
  return (
    <div>
      {children && <div className="flex justify-center items-center" onClick={() => setShowShare(true)}>{children}</div>}
      <ShareSheet
        visible={showShare}
        addressVisible={isCompany}
        shareList={sharerList}
        shareSetting={shareSetting}
        mySharePermission={mySharePermission}
        onCopyLink={() => {
          if (shareInfo?.url) {
            const text = `${shareInfo.url} 《${title}》${isPassWord ? `密码：${shareSetting.password}` : ""}`;
            console.log(text);
            if(navigator?.clipboard) {
              navigator?.clipboard?.writeText(text)
                .then(() => {
                  message.success("复制成功");
                })
                .catch((err) => {
                  message.error("复制失败，请手动复制");
                  console.error("Clipboard error:", err);
                }); 
            } else {
              const input = document.createElement("input");
              input.value = text;
              document.body.appendChild(input);
              input.select();
              document.execCommand('copy');
              document.body.removeChild(input);
              message.success("复制成功");
            }
          }
        }}
        shareInfo={shareInfo}
        disabled={!editable}
        onShareSettingChange={onShareSettingChange}
        onClose={() => setShowShare(false)}
        onShowShare={() => setShowShareMember(true)}
        onShowAddress={() => setShowAddress(true)}
        onShowLinkShare={() => setShowLinkShare(true)}
        onShowSecurity={() => setShowSecurity(true)} />
      <ShareMemberSheet
        visible={showShareMember}
        addressVisible={isCompany}
        onClose={() => setShowShareMember(false)}
        shareId={shareInfo?.shareId}
        mySharePermission={mySharePermission}
        shareList={sharerList}
        removeShareMember={removeShareMember}
        updateShareMenber={updateShareMenber}
        inviteMember={inviteMember}
      />
      <AddressSheet
        visible={showAddress}
        shareId={shareInfo?.shareId}
        onClose={() => setShowAddress(false)}
        mySharePermission={mySharePermission}
        onAdded={async (addedUsers) => {
          const res = await inviteMember(addedUsers);
          res && setShowAddress(false);
        }}
      />
      <LinkShareSheet
        visible={showLinkShare}
        isCompany={isCompany}
        shareScope={shareSetting.shareScope}
        onClose={() => setShowLinkShare(false)}
        onShareScopeChange={(value) => {
          updateShareScope(value as PermissionChoose);
        }}
        password={shareSetting.password}
        onPasswordChange={(value) => {
          updatePassword(value);
        }}
      />
      <SecuritySheet
        visible={showSecurity}
        expiredTime={shareInfo?.expiredTime}
        onClose={() => setShowSecurity(false)}
        linkValidity={shareSetting.linkValidity}
        onLinkValidityChange={(value) => {
          onShareSettingChange({ linkValidity: value as LinkValidPeriodType });
        }}
        allowBackUp={shareSetting.allowBackUp}
        onAllowBackUpChange={(value) => {
          onShareSettingChange({ allowBackUp: value });
        }}
        allowExport={shareSetting.allowExport}
        onAllowExportChange={(value) => {
          onShareSettingChange({ allowExport: value });
        }}
        watermarkEnable={shareSetting.waterMarkEnable}
        onWatermarkEnableChange={(value) => {
          onShareSettingChange({ waterMarkEnable: value });
        }} >
      </SecuritySheet>
    </div>
  );
};

export const openShareSheet = (info: IShareProps) => {
  const root = document.getElementById("root");
  const div = document.createElement("div");
  root?.appendChild(div);
  const modal = <ShareActionSheet {...info} />;
  ReactDOM.createRoot(div).render(modal);
};

export default ShareActionSheet;
